import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'mailTo',
    standalone: false
})
export class MailToPipe implements PipeTransform {

	transform(emailAdress: string | undefined): string {
		return emailAdress ? `mailto:${emailAdress}` : '';
	}

}
